/**
 * The full-page Ask HF AI chat. The side panel never opens on it
 * (chat-companion.tsx), so nothing should make room for, or hide behind, a
 * panel there (#933).
 */
export const FULL_PAGE_CHAT_PATH = '/recipients/ai-chat'
